import { render, staticRenderFns } from "./SfSection.vue?vue&type=template&id=94921aac"
import script from "./SfSection.vue?vue&type=script&lang=js"
export * from "./SfSection.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./SfSection.vue?vue&type=style&index=0&id=94921aac&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  "76a28598"
  
)

export default component.exports